import React from "react";


const Vision = () => {
    return (
        <section >
            <br/>
            <br/>

            <div className="row row-cols-1 row-cols-md-3 g-4">
                <div className="col">
                    <div className="card h-90 shadow p-3 mb-5 bg-body rounded">
                        <img
                            src="https://miro.medium.com/max/1000/1*AlKsj9A2fKYOF1X8oO88zw.png"
                            className="card-img-top  custom-img-bg rounded-3"
                            alt="..."
                        />
                        <div className="card-body">
                            <h5 className="card-title">OUR MISSION</h5>
                            <p className="card-text">
                            Light is our life. We will continually innovate and grow to create world leading lighting solutions.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card h-0 shadow p-3 mb-5 bg-body rounded ">
                        <img
                            src="https://images.ctfassets.net/ke8zgcubcfkc/3CQBFqtgRiDEeoey3Nf1gS/34aceeeeae9d3b62e85b65af46e58b06/Loesungskompetenz_1000x500.jpg"
                            className="card-img-top  custom-img-bg rounded-3"
                            alt="..."
                        />
                        <div className="card-body">
                            <h5 className="card-title">OUR VISION</h5>
                            <p className="card-text">
                            We are committed to delivering the most innovative effective lighting solutions with world class products and service.
                            </p>

                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card h-90 shadow p-3 mb-5 bg-body rounded ">
                        <img
                            src="https://flyingcatmarketing.com/wp-content/uploads/13739-Qualified-traffic-graphic-1b.jpg"
                            className="card-img-top  custom-img-bg rounded-3"
                            alt="..."
                        />
                        <div className="card-body">
                            <h5 className="card-title">OUR GOAL</h5>
                            <p className="card-text">
                            The Lighting Design Objectives Procedure is based on the proposition that the prime purpose of indoor lighting is to satisfy .
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Vision;
